import type { SidebarNode } from '@frontend-platform/dev-shell';
import { Activity, BarChart3, House, MessageSquare, Sparkles, Target } from 'lucide-react';
import { ROUTES } from '@/config/routes';

export const OBSERVATION_TOOLS_SIDEBAR: SidebarNode[] = [
  {
    kind: 'section',
    label: 'Home',
    defaultExpanded: true,
    children: [{ kind: 'item', label: 'AI Agent Overview', icon: House }],
  },
  { kind: 'section', label: 'Build' },
  { kind: 'section', label: 'Evaluate' },
  {
    kind: 'section',
    label: 'Monitor',
    defaultExpanded: true,
    children: [
      { kind: 'item', label: 'Insights', icon: BarChart3, expandable: true },
      { kind: 'item', label: 'Conversations', icon: MessageSquare, expandable: true },
      { kind: 'item', label: 'Optimize', icon: Sparkles },
      { kind: 'item', label: 'Calibration', icon: Target, href: ROUTES.HOME },
      { kind: 'item', label: 'Activity Log', icon: Activity },
    ],
  },
  { kind: 'section', label: 'Channel' },
  { kind: 'section', label: 'Control' },
  { kind: 'section', label: 'Settings' },
];
